var _toConsumableArray = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _classCallCheck = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var TextFunctions = require('../formulas/functions/text');

var MathFunctions = require('../formulas/functions/math');

var TrigFunctions = require('../formulas/functions/trigonometry');

var LogicalFunctions = require('../formulas/functions/logical');

var EngFunctions = require('../formulas/functions/engineering');

var ReferenceFunctions = require('../formulas/functions/reference');

var InformationFunctions = require('../formulas/functions/information');

var StatisticalFunctions = require('../formulas/functions/statistical');

var DateFunctions = require('../formulas/functions/date');

var FormulaError = require('../formulas/error');

var _require = require('../formulas/helpers'),
    FormulaHelpers = _require.FormulaHelpers;

var _require2 = require('./parsing'),
    Parser = _require2.Parser,
    allTokens = _require2.allTokens;

var lexer = require('./lexing');

var Utils = require('./utils');
/**
 * A Excel Formula Parser & Evaluator
 */


var FormulaParser = /*#__PURE__*/function () {
  "use strict";

  /**
   * @param {{functions: {}, onVariable: function, onCell: function, onRange: function}} [config]
   * @param isTest - is in testing environment
   */
  function FormulaParser(config) {
    var isTest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, FormulaParser);

    this.logs = [];
    this.isTest = isTest;
    this.utils = new Utils(this);
    config = Object.assign({
      functions: {},
      onVariable: function onVariable() {
        return null;
      },
      onCell: function onCell() {
        return 0;
      },
      onRange: function onRange() {
        return [[0]];
      }
    }, config);
    this.onVariable = config.onVariable;
    this.functions = Object.assign({}, DateFunctions, StatisticalFunctions, InformationFunctions, ReferenceFunctions, EngFunctions, LogicalFunctions, TextFunctions, MathFunctions, TrigFunctions, config.functions);
    this.onRange = config.onRange;
    this.onCell = config.onCell; // functions treat null as 0, other functions treats null as ""

    this.funsNullAs0 = Object.keys(MathFunctions).concat(Object.keys(TrigFunctions)).concat(Object.keys(LogicalFunctions)).concat(Object.keys(EngFunctions)).concat(Object.keys(ReferenceFunctions)).concat(Object.keys(StatisticalFunctions)).concat(Object.keys(DateFunctions)); // functions need context and don't need to retrieve references

    this.funsNeedContextAndNoDataRetrieve = ['ROW', 'ROWS', 'COLUMN', 'COLUMNS', 'SUMIF', 'INDEX', 'AVERAGEIF'];
    this.funsNeedContext = [];
    this.funsPreserveRef = Object.keys(InformationFunctions);
    this.parser = new Parser(this, this.utils);
  }
  /**
   * Get all lexing token names. Webpack needs this.
   * @return {Array.<string>} - All token names that should not be minimized.
   */


  _createClass(FormulaParser, [{
    key: "getCell",

    /**
     * Get value from the cell reference
     * @param ref
     * @return {*}
     */
    value: function getCell(ref) {
      // console.log('get cell', JSON.stringify(ref));
      if (ref.sheet == null) ref.sheet = this.position ? this.position.sheet : undefined;
      return this.onCell(ref);
    }
    /**
     * Get values from the range reference.
     * @param ref
     * @return {*}
     */

  }, {
    key: "getRange",
    value: function getRange(ref) {
      // console.log('get range', JSON.stringify(ref));
      if (ref.sheet == null) ref.sheet = this.position ? this.position.sheet : undefined;
      return this.onRange(ref);
    }
    /**
     * TODO:
     * Get references or values from a user defined variable.
     * @param name
     * @return {*}
     */

  }, {
    key: "getVariable",
    value: function getVariable(name) {
      // console.log('get variable', name);
      var res = {
        ref: this.onVariable(name, this.position.sheet)
      };
      if (res.ref == null) return FormulaError.NAME;
      return res;
    }
    /**
     * Retrieve values from the given reference.
     * @param valueOrRef
     * @return {*}
     */

  }, {
    key: "retrieveRef",
    value: function retrieveRef(valueOrRef) {
      if (FormulaHelpers.isRangeRef(valueOrRef)) {
        return this.getRange(valueOrRef.ref);
      }

      if (FormulaHelpers.isCellRef(valueOrRef)) {
        return this.getCell(valueOrRef.ref);
      }

      return valueOrRef;
    }
    /**
     * The functions that can return a reference instead of a value as normal functions.
     * Note: Not all functions from "Lookup and reference" category can return a reference.
     * {@link https://support.office.com/en-ie/article/lookup-and-reference-functions-reference-8aa21a3a-b56a-4055-8257-3ec89df2b23e}
     * @param name - Reference function name.
     * @param args - Arguments that pass to the function.
     */

  }, {
    key: "callRefFunction",
    value: function callRefFunction(name, args) {
      name = name.toUpperCase();

      if (this.functions[name]) {
        var res;

        try {
          var _this$functions;

          res = (_this$functions = this.functions)[name].apply(_this$functions, [this].concat(_toConsumableArray(args)));
        } catch (e) {
          // allow functions throw FormulaError, this make functions easier to implement!
          if (e instanceof FormulaError) {
            return e;
          } else {
            throw e;
          }
        }

        if (res === undefined) {
          return {
            value: 0,
            ref: {}
          };
        }

        return FormulaHelpers.checkFunctionResult(res);
      } else {
        if (!this.logs.includes(name)) this.logs.push(name); // console.log(`Function ${name} is not implemented`);

        return {
          value: 0,
          ref: {}
        };
      }
    }
    /**
     * Call an excel function.
     * @param name - Function name.
     * @param args - Arguments that pass to the function.
     * @return {*}
     */

  }, {
    key: "callFunction",
    value: function callFunction(name, args) {
      var _this = this;

      if (name.indexOf('_xlfn.') === 0) name = name.slice(6);
      name = name.toUpperCase(); // if one arg is null, it means 0 or "" depends on the function it calls

      var nullValue = this.funsNullAs0.includes(name) ? 0 : '';

      if (!this.funsNeedContextAndNoDataRetrieve.includes(name)) {
        // retrieve reference
        args = args.map(function (arg) {
          if (arg === null) return {
            value: nullValue,
            isArray: false,
            omitted: true
          };

          var res = _this.utils.extractRefValue(arg);

          if (_this.funsPreserveRef.includes(name)) {
            return {
              value: res.val,
              isArray: res.isArray,
              ref: arg.ref
            };
          }

          return {
            value: res.val,
            isArray: res.isArray,
            isRangeRef: !!FormulaHelpers.isRangeRef(arg),
            isCellRef: !!FormulaHelpers.isCellRef(arg)
          };
        });
      } // console.log('callFunction', name, args)


      if (this.functions[name]) {
        var res;

        try {
          var _this$functions2, _this$functions3;

          if (!this.funsNeedContextAndNoDataRetrieve.includes(name) || this.funsNeedContext.includes(name)) res = (_this$functions2 = this.functions)[name].apply(_this$functions2, _toConsumableArray(args));else res = (_this$functions3 = this.functions)[name].apply(_this$functions3, [this].concat(_toConsumableArray(args)));
        } catch (e) {
          // allow functions throw FormulaError, this make functions easier to implement!
          if (e instanceof FormulaError) {
            return e;
          } else {
            throw e;
          }
        }

        if (res === undefined) {
          // console.log(`Function ${name} may be not implemented.`);
          if (this.isTest) {
            if (!this.logs.includes(name)) this.logs.push(name);
            return {
              value: 0,
              ref: {}
            };
          }

          throw FormulaError.NOT_IMPLEMENTED(name);
        }

        return FormulaHelpers.checkFunctionResult(res);
      } else {
        // console.log(`Function ${name} is not implemented`);
        if (this.isTest) {
          if (!this.logs.includes(name)) this.logs.push(name);
          return {
            value: 0,
            ref: {}
          };
        }

        throw FormulaError.NOT_IMPLEMENTED(name);
      }
    }
    /**
     * Return currently supported functions.
     * @return {this}
     */

  }, {
    key: "supportedFunctions",
    value: function supportedFunctions() {
      var _this2 = this;

      var supported = [];
      var functions = Object.keys(this.functions);
      functions.forEach(function (fun) {
        var res;

        try {
          res = _this2.functions[fun](0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
          if (res === undefined) return;
          supported.push(fun);
        } catch (e) {
          if (e instanceof FormulaError || e instanceof TypeError) supported.push(fun); // else
          //     console.log(e)
        }
      });
      return supported.sort();
    }
    /**
     * Check and return the appropriate formula result.
     * @param result
     * @param {boolean} [allowReturnArray] - If the formula can return an array
     * @return {*}
     */

  }, {
    key: "checkFormulaResult",
    value: function checkFormulaResult(result) {
      var allowReturnArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var type = typeof result; // number

      if (type === 'number') {
        if (isNaN(result)) {
          return FormulaError.VALUE;
        } else if (!isFinite(result)) {
          return FormulaError.NUM;
        }

        result += 0; // make -0 to 0
      } else if (type === 'object') {
        if (result instanceof FormulaError) return result;

        if (allowReturnArray) {
          if (result.ref) {
            result = this.retrieveRef(result);
          }

          if (Array.isArray(result)) {
            return result;
          } else {
            return FormulaError.VALUE;
          }
        } else {
          if (result.ref && result.ref.row && !result.ref.from) {
            // single cell reference
            result = this.retrieveRef(result);
          } else if (result.ref && result.ref.from && result.ref.from.col === result.ref.to.col) {
            // single Column reference
            result = this.retrieveRef({
              ref: {
                row: result.ref.from.row,
                col: result.ref.from.col
              }
            });
          } else if (Array.isArray(result)) {
            result = result[0][0];
          } else {
            // array, range reference, union collections
            return FormulaError.VALUE;
          }
        }
      }

      return result;
    }
    /**
     * Parse an excel formula.
     * @param inputText
     * @param {{row: number, col: number}} [position] - The position of the parsed formula
     *              e.g. {row: 1, col: 1}
     * @param {boolean} [allowReturnArray] - If the formula can return an array. Useful when parsing array formulas,
     *                                      or data validation formulas.
     * @returns {*}
     */

  }, {
    key: "parse",
    value: function parse(inputText, position) {
      var allowReturnArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (inputText.length === 0) throw Error('Input must not be empty.');
      this.position = position;
      var lexResult = lexer.lex(inputText);
      this.parser.input = lexResult.tokens;
      var res;

      try {
        res = this.parser.formulaWithBinaryOp();
        res = this.checkFormulaResult(res, allowReturnArray);

        if (res instanceof FormulaError) {
          return res;
        }
      } catch (e) {
        // console.log(e);
        throw e;
      }

      if (this.parser.errors.length > 0) {
        var error = this.parser.errors[0];
        var line = error.previousToken.startLine,
            column = error.previousToken.startColumn + 1;
        var msg = '\n' + inputText.split('\n')[line - 1] + '\n';
        msg += Array(column - 1).fill(' ').join('') + '^\n';
        error.message = msg + "Error at position ".concat(line, ":").concat(column, "\n") + error.message;
        throw error;
      }

      return res;
    }
  }], [{
    key: "allTokens",
    get: function get() {
      return allTokens;
    }
  }]);

  return FormulaParser;
}();

module.exports = {
  FormulaParser: FormulaParser,
  FormulaHelpers: FormulaHelpers
};